import React from "react";
export default function PageHeader({ title, subtitle, actions, }: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
}): any {
    return (<div className="mb-6 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-fg">{title}</h1>
        {subtitle && <p className="mt-0.5 text-sm text-fg-subtle">{subtitle}</p>}
      </div>
      {actions && (<div className="flex items-center gap-2 mt-2 sm:mt-0">{actions}</div>)}
    </div>);
}
